"use client";

import { useState } from "react";
import { Box, styled } from "@mui/material";
import { Tabs, TabList, Tab, TabPanel } from "@/ui";
import SummaryTab from "./Summary/SummaryTab";
import NotesTab from "./Notes/NotesTab";
import FilesTab from "./Files/FilesTab";
import ImageUpload from "../modals/parts/ImageUpload";

const AvatarPanel = styled(Box)({
  width: "200px",
  height: "200px",
});

const TabsSection = styled(Box)({
  background: "var(--bg-muted)",
  borderRadius: "var(--radius-md)",
  overflow: "hidden",
  paddingTop: "var(--space-5)",
});

const TabStrip = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

const Panel = styled(Box)({
  padding: "0 32px 32px",
});

export default function CandidateTabs({
  candidate,
  candidateId,
  profile,
  onImageUpdate,
  onAvatarFromLibrary,
  onDownloadOriginal,
  onDownloadFormatted,
  onDownloadFormattedOriginal,
  hasResume,
  recruiterLogoUrl,
  isGeneratingSummary,
}) {
  const [tab, setTab] = useState("summary");

  return (
    <TabsSection>
      <Tabs value={tab} onChange={setTab}>
        <TabStrip>
          <TabList>
            <Tab value="summary">Summary</Tab>
            <Tab value="profile">Profile</Tab>
            <Tab value="avatar">Avatar</Tab>
            <Tab value="notes">Notes</Tab>
            <Tab value="files">Files</Tab>
          </TabList>
        </TabStrip>
        <Panel>
          <TabPanel value="summary">
            <SummaryTab
              candidate={candidate}
              isGeneratingSummary={isGeneratingSummary}
            />
          </TabPanel>
          <TabPanel value="profile">{profile}</TabPanel>
          <TabPanel value="avatar">
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <AvatarPanel>
                <ImageUpload
                  imageUrl={candidate.photo_url}
                  name={candidate.name}
                  onUpdate={onImageUpdate}
                  onSelectFromLibrary={onAvatarFromLibrary}
                />
              </AvatarPanel>
            </Box>
          </TabPanel>
          <TabPanel value="notes">
            <NotesTab candidateId={candidateId} />
          </TabPanel>
          <TabPanel value="files">
            <FilesTab
              onDownloadOriginal={onDownloadOriginal}
              onDownloadFormatted={onDownloadFormatted}
              onDownloadFormattedOriginal={onDownloadFormattedOriginal}
              hasResume={hasResume}
              recruiterLogoUrl={recruiterLogoUrl}
            />
          </TabPanel>
        </Panel>
      </Tabs>
    </TabsSection>
  );
}
